
import $ from 'jquery';

export const languageSelector = () => {
  if (!window.serverdata.configMeta.aim.languageSelector?.showAimLanguages || !window.serverdata.configMeta.aim.languageSelector?.languages) { return; }

  $('body').on('click', '.language__selector', function (e) {
    e.preventDefault();

    $(this).toggleClass('active');
    $('.language__selector__expand').toggleClass('language__selector__expand_more language__selector__expand_less');
    $('.language__menu').toggleClass('language__menu__show');
  });

  $('body').on('click', '.language__menu__item', function (e) {
    e.preventDefault();
    const selLang = this.innerText.trim();
    localStorage.setItem('currentLanguage', window.serverdata.configMeta.aim.languageSelector.languages.find((i) => i.displayName.includes(selLang)).langCode);
    location.reload();
  });

  const currentLangCode = localStorage.getItem('currentLanguage') || window.serverdata.configMeta.aim.lang;
  return languageSelectorTemplate({
    languages: window.serverdata.configMeta.aim.languageSelector.languages,
    currentLanguage:
      window.serverdata.configMeta.aim.languageSelector.languages.find((i) => i.langCode.includes(currentLangCode)).displayName
  });
};

export const languageSelectorTemplate = (obj) => {
  const langs = obj.languages.map(({ displayName, langCode }) => {
    return `
            <a class="language__menu__item ${obj.currentLanguage === displayName ? 'current' : ''}" href="#">
                <span class="material-icons-outlined language__menu__item__icon"></span>
                ${displayName}
            </a>`;
  });

  return `
        <div class="language__selector">
            <span class="material-icons-outlined language__selector__icon">language</span>
            <span class="language__selector__text">${obj.currentLanguage}</span>
            <span class="material-icons-outlined language__selector__expand language__selector__expand_more"></span>
            <div class="language__menu">
                ${langs.join('')}
            </div>
        </div>
    `;
};
export { languageSelector as default };
